export default "__VITE_ASSET__BNL4M3lK__"